/* eslint-disable */
export default {
  logging: 'Wordt gelogd...',
  logCall: 'Oproep loggen',
  editLog: 'Lijst bewerken',
  select: 'Selecteer een overeenkomende opname',
  OnHold: 'In de wacht',
  Ringing: 'Gaat over',
  CallConnected: 'Oproep verbonden',
  unknownUser: 'Onbekende gebruiker',
  unknownNumber: 'Anoniem',
  unavailable: 'Niet beschikbaar',
  viewDetails: 'Details weergeven',
  addEntity: 'Nieuwe maken',
  addLog: 'Lijst',
  text: 'Tekstbericht',
  call: 'Oproep',
  addContact: 'Contactpersoon toevoegen',
  missedCall: 'Gemist',
  inboundCall: 'Inkomend',
  outboundCall: 'Uitgaand',
  from: 'Van',
  to: 'Aan',
  hangup: 'Ophangen',
  accept: 'Beantwoorden',
  toVoicemail: 'Naar voicemail',
  anonymous: 'Anoniem',
  mergeToConference: 'Samenvoegen met actieve oproep',
  hold: 'Wacht',
  unhold: 'Uit de wacht',
  transfer: 'Doorschakelen',
  reject: 'Weigeren',
  switchCall: 'Oproep naar deze app schakelen',
  callSwitch: 'Oproep schakelen',
  comfirmContext:
    'U bent momenteel in een actieve oproep met {displayName}. Wilt u de oproep voortzetten op dit apparaat?',
  comfirmCancelButton: 'Annuleren',
  comfirmOKButton: 'Schakelen',
  ignore: 'Negeren',
  holdAndAnswer: 'In wacht en beantwoorden',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"addContact"@#@ @source: @#@"Add Contact"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"from"@#@ @source: @#@"From"@#@
// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"accept"@#@ @source: @#@"Answer"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"unhold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"switchCall"@#@ @source: @#@"Switch Call to this app"@#@
// @key: @#@"callSwitch"@#@ @source: @#@"Call Switch"@#@
// @key: @#@"comfirmContext"@#@ @source: @#@"You're currently on an active call with {displayName}. Would you like to continue the call on this device?"@#@
// @key: @#@"comfirmCancelButton"@#@ @source: @#@"Cancel"@#@
// @key: @#@"comfirmOKButton"@#@ @source: @#@"Switch"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
